import instructRequest,{TipPlugin,VerificationPlugin,CachePlugin} from "instruct-request-axios";
import {message as vMessage} from 'ant-design-vue';

export function openMessage(type,message){
    return vMessage[type](message);
}

const request = instructRequest.create({
    baseURL:'https://bizconfstreaming.yunkust.com/',
    method:'post',
    // headers:{
    //   'Content-Type':'application/x-www-form-urlencoded'
    // },
    message:{
        // success: (content)=> openMessage('success',content),
        fail: (content)=> openMessage('fail',content),
        info: (content)=> openMessage('info',content),
        warning: (content)=> openMessage('warning',content),
    },
    responseCode:[1]
});

TipPlugin.register(request,{
    messageKey:'info'
});

CachePlugin.register(request,{
    storage:'local'
});

VerificationPlugin.register(request);


export default request;
